export default __webpack_public_path__ + "static/media/leaderboard_no_attempts.ed94cec3.svg";